<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Paslaugos ir veiksmai') }}</h1>
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Pridėti naują"
      :loading="loading"
      @click.native.stop="newItem()"
    />
      <el-button
      class="mb-5 ml-1"
      color="primary"
      icon="pridėti"
      title="Pridėti IS identifikatorių"
      :loading="loading"
      @click.native.stop="openModal()"
    />
    <!-- import -->
      <el-button
      class="mb-5 ml-1"
      color="primary"
      title="Įkelti "
      :loading="loading"
      @click.native.stop="goToImport()"
    />
    <!-- export -->
    <el-button
      class="mb-5  ml-1"
      color="secondary"
      title="Išeksportuoti "
      :loading="loading"
      @click.native.stop="exportXls()"
    />
    <!-- search -->
    <services-search @downloadReport="downloadReport" :loading="loading" @search="searchServices" />
    <!-- mapped -->
    <action-mapped></action-mapped>
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template v-slot:item="{ item }">
        <el-table-service-row
          @newItem="newListItem"
          @editItem="editItem"
          @deleteItem="deleteItem"
          :item="item"
          :level="1"
          show
        />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <!-- modals -->
  <modal-add-is-identificator v-if="showModal" @close-modal="closeModal" />
  </v-container>
</template>

<script>
import ServicesSearch from './AdminServicesSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'
import ModalAddIsIdentificator from '../../../components/modals/ModalAddIsIdentificator.vue'
import ActionMapped from './ActionMapped.vue'

export default {
  name: 'Services',
  components: {
    ServicesSearch,
    ModalDelete,
    ModalAddIsIdentificator,
    ActionMapped,
  },
  mixins: [userRole, tableParameters, math],
  data() {
    return {
      showModal: false,
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: '',
          align: 'right',
          sortable: false,
          value: '',
          width: '1%',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '8rem',
        },
        {
          text: this.$t('Paslaugos kodas'),
          align: 'start',
          value: 'code',
          width: '7rem',
        },
        {
          text: this.$t('Institucijos kodas'),
          align: 'start',
          value: 'institution_code',
          width: '7rem',
        },
        {
          text: this.$t('Institucijos pavadinimas'),
          align: 'start',
          value: 'institution_fullname',
          width: '9rem',
        },
        {
          text: this.$t('PASIS kodas'),
          align: 'start',
          value: 'pasis_code',
          width: '9rem',
        },
        {
          text: this.$t('Paslaugos pavadinimas (LT)'),
          align: 'start',
          value: 'title_lt',
          width: '20rem',
        },
        {
          text: this.$t('Paslaugos pavadinimas (EN)'),
          align: 'start',
          value: 'title_en',
          width: '20rem',
        },
        {
          text: this.$t('IS identifikatorius'),
          align: 'start',
          value: 'is_identificator',
          width: '10rem',
        },
        {
          text: this.$t('Paslaugos tipas'),
          align: 'start',
          value: 'type',
          width: '9rem',
        },
        {
          text: this.$t('El. paslauga'),
          align: 'start',
          value: 'digital_service',
          width: '8rem',
        },
        {
          text: this.$t('Reikalingas el. parašas'),
          align: 'start',
          value: 'signature_required',
          width: '7.8rem',
        },
        {
          text: this.$t('Tik notarinis'),
          align: 'start',
          value: 'notarial_only',
          width: '7.8rem',
        },
        {
          text: this.$t('Prokūra'),
          align: 'start',
          value: 'procuration_law',
          width: '6rem',
        },
        {
          text: this.$t('Aktyvumas'),
          align: 'start',
          value: 'is_active',
          width: '8rem',
        },
        {
          text: this.$t('NIRVAR sričių skaičius'),
          align: 'start',
          value: 'nirvars_count',
          width: '8rem',
        },
        {
          text: this.$t('Papildomų laukų rinkinys'),
          align: 'start',
          value: 'action_extra_field_set_id',
          width: '14rem',
        },
        {
          text: this.$t('Galioja nuo'),
          align: 'start',
          value: 'valid_from',
          width: '8rem',
        },
        {
          text: this.$t('Galioja iki'),
          align: 'start',
          value: 'valid_to',
          width: '7rem',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    openModal(){
      this.showModal = true
    },
    closeModal(){
      this.showModal = false
    },
    newItem() {
      this.$router.push({
        name: 'adminServiceForm',
      })
    },
    newListItem(item) {
      this.$router.push({
        name: 'adminParentServiceForm',
        params: {
          parent_id: item?.id || null,
        },
      })
    },
    editItem(item, mode) {
      this.$router.push({
        name: 'adminServiceForm',
        params: {
          id: item.id,
          parent_id: item?.parent_id || null,
        },
      })
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`actions/list`, data)
        .then((res) => {
          this.listData = res.data.actions
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchServices(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`actions/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    exportXls(){
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isExport: true
      }
      this.$axios
        .post(`actions/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
          .post(`actions/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    goToImport(){
      this.$router.push({ name: 'adminServiceImportForm' })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
